<template>
  <image-modal :modalActive="activeModal" @close="togglePopup('loading.jpg')"
    :imageName="imageName">
  </image-modal>

  <right-banner-template :title="title">
    <div class="layout-content">
      <!-- <img @contextmenu.prevent :src="require(`../../assets/${$store.getters['student/finalClassLayout']}`)"> -->
      <div class="E-layout">
        <img @contextmenu.prevent :src="require(`../../assets/buildingLayout/E-Layout.jpg`)">

        <button class="btn-hidden btn-e-popup e-fl4" @click="togglePopup('E-fl4.jpg')">
          <span class="tooltip">Click me!</span>
        </button>

        <button class="btn-hidden btn-e-popup e-fl3" @click="togglePopup('E-fl3.jpg')">
          <span class="tooltip">Click me!</span>
        </button>

        <button class="btn-hidden btn-e-popup e-fl2" @click="togglePopup('E-fl2.jpg')">
          <span class="tooltip">Click me!</span>
        </button>

        <button class="btn-hidden btn-e-popup e-fl1" @click="togglePopup('E-fl1.jpg')">
          <span class="tooltip">Click me!</span>
        </button>

        <button class="btn-hidden btn-e-popup e-fl0" @click="togglePopup('E-fl0.jpg')">
          <span class="tooltip">Click me!</span>
        </button>
      </div>

      <div class="sim-layout">
        <img @contextmenu.prevent :src="require(`../../assets/buildingLayout/SIM-Layout.jpg`)">
        <!-- <img @contextmenu.prevent :src="cacheBuster('/TheMedia/Sơ%20đồ%20phòng%20học%20-c91f3694-1e90-4726-bbbd-dbdf19a235f0.jpg')"> -->
        <button class="btn-hidden btn-popup sim-fl2" @click="togglePopup('SIM-fl2.jpg')">
          <span class="tooltip">Click me!</span>
        </button>

        <button class="btn-hidden btn-popup sim-fl1" @click="togglePopup('SIM-fl1.jpg')">
          <span class="tooltip">Click me!</span>
        </button>

        <button class="btn-hidden btn-popup sim-fl0" @click="togglePopup('SIM-fl0.jpg')">
          <span class="tooltip">Click me!</span>
        </button>
      </div>
    </div>
  </right-banner-template>
</template>

<script>
export default {
  props: ['title'],
  data () {
    return {
      activeModal: false,
      imageName: 'SIM-fl0.jpg'
    }
  },
  methods: {
    cacheBuster (url) {
      return `${url}?cacheBuster=${new Date().getTime()}`
    },
    togglePopup (image) {
      this.imageName = image
      this.activeModal = !this.activeModal
    }
  }
}
</script>

<style scoped>
  .layout-content {
    width: 100%;
  }

  .layout-content img {
    max-width: 100%;
  }

  .sim-layout {
    position: relative;
    display: inline-block;
  }

  .btn-popup {
    padding: 16px 50px;
    background: transparent;
    border: none;
    cursor: pointer;
    border-radius: 15px;
  }

  .sim-fl2 {
    position: absolute;
    top: 24%;
    left: 50%;
    transform: translate(-80%, -50%);
  }

  .sim-fl1 {
    position: absolute;
    top: 39%;
    left: 50%;
    transform: translate(-80%, -50%);
  }

  .sim-fl0 {
    position: absolute;
    top: 66.6%;
    left: 50%;
    transform: translate(-80%, -50%);
  }

  .btn-e-popup {
    padding: 16px 71px;
    border: none;
    cursor: pointer;
    border-radius: 15px;
    background: transparent;
    border: none;
    cursor: pointer;
  }

  .E-layout {
    margin-bottom: 50px;
    position: relative;
    display: inline-block;
  }

  .e-fl4 {
    position: absolute;
    top: 21%;
    left: 50%;
    transform: translate(-49%, -50%);
  }

  .e-fl3 {
    position: absolute;
    top: 27%;
    left: 50%;
    transform: translate(-49%, -50%);
  }

  .e-fl2 {
    position: absolute;
    top: 39.3%;
    left: 50%;
    transform: translate(-49%, -50%);
  }

  .e-fl1 {
    position: absolute;
    top: 61.8%;
    left: 50%;
    transform: translate(-49%, -50%);
  }

  .e-fl0 {
    position: absolute;
    top: 79.8%;
    left: 50%;
    transform: translate(-49%, -50%);
  }

  .btn-hidden .tooltip {
    position: absolute;
    top: 110%;
    left: 50%;
    transform: translateX(-50%);
    color: #006884;
    padding: 5px;
    border-radius: 5px;
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
    font-weight: bold;
  }

  .btn-hidden:hover .tooltip {
    opacity: 1;
  }

  @media (min-width: 1850px) {
    .btn-e-popup {
      padding: 20px 92px;
    }

    .btn-popup {
      padding: 22px 66px;
    }
  }

  @media (max-width: 1450px) {
    .btn-e-popup {
      padding: 12px 55px;
    }

    .btn-popup {
      padding: 12px 41px;
    }
  }

  @media (max-width: 1225px) {
    .btn-hidden .tooltip {
      display: none;
    }
  }
</style>
